import { render, staticRenderFns } from "./ProjectUpdates.vue?vue&type=template&id=353d1c96&scoped=true&"
import script from "./ProjectUpdates.vue?vue&type=script&lang=js&"
export * from "./ProjectUpdates.vue?vue&type=script&lang=js&"
import style0 from "./ProjectUpdates.vue?vue&type=style&index=0&id=353d1c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353d1c96",
  null
  
)

export default component.exports